// Libs
import React from 'react'
import ReactSVG from 'react-svg'

// Imgs
import logoFull from '../../assets/logos/com-acordo-completo2.svg'

//CSS
import './styles.scss'

const LogoFull = (props) => {
  const { width, height, gutter, gutterTop, gutterBottom } = props

  const logoIconStyle = {
    width: `${width}px`,
    height: `${height}px`,
    margin: `${gutter}px 0`,
    marginTop: `${gutterTop}px`,
    marginBottom: `${gutterBottom}px`,
  }

  return (
    <div className="logo-full" style={logoIconStyle}>
      <ReactSVG src={logoFull} />
    </div>
  )
}

export default LogoFull
